import { openDialog } from '@patrianna/dialog-manager'
import { useEffect } from 'react'

import { ASYNC_OFFER_DIALOG_KEY } from 'config/defaults'
import { useAppSelector } from 'store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import { getDataFromSessionStorage, removeDataFromSessionStorage } from 'utils/sessionStorage'

// todo move it to payment package - usePaymentDialogs
export default function usePaymentDialogs() {
  const loggedIn = useAppSelector(isLoggedInSelector)

  useEffect(() => {
    const query = getDataFromSessionStorage<Record<string, unknown>>(ASYNC_OFFER_DIALOG_KEY)

    if (query && loggedIn && typeof query === 'object') {
      const { dialogName, ...dialogProps } = query
      if (typeof dialogName !== 'string') {
        return
      }
      openDialog({ dialogName, dialogProps })

      removeDataFromSessionStorage(ASYNC_OFFER_DIALOG_KEY)
    }
  }, [loggedIn])
}
